import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Copy, CheckCircle2, ExternalLink } from "lucide-react";
import { Button } from "../components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

const EASTER_HTML = `<!DOCTYPE html>
<html lang="it">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Auguri di Pasqua - ODR | ITA318</title>
</head>
<body style="margin:0;padding:0;background-color:#f8f5f0;font-family:'Georgia','Times New Roman',serif;">

<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#f8f5f0;">
<tr><td align="center" style="padding:30px 15px;">

<table role="presentation" width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;background-color:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 4px 24px rgba(0,0,0,0.06);">

<!-- Header con logo -->
<tr><td style="background:linear-gradient(135deg,#2d2426 0%,#3d3436 100%);padding:32px 40px;text-align:center;">
  <img src="https://customer-assets.emergentagent.com/job_9af1c8bb-f3cd-45ad-967d-133bf06715e5/artifacts/lz1fr6l3_ITA318.png" alt="ODR Academy | ITA318" style="max-width:200px;height:auto;" />
</td></tr>

<!-- Immagine principale -->
<tr><td style="padding:0;">
  <img src="https://images.unsplash.com/photo-1710381473274-681efdc537f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzcHJpbmclMjBmbG93ZXJzJTIwZ29sZGVuJTIwbGlnaHQlMjBlbGVnYW50JTIwcGFzdGVsJTIwdHVsaXBzfGVufDB8fHx8MTc3NTI4NDM3M3ww&ixlib=rb-4.1.0&q=85" alt="Primavera e rinascita" style="width:100%;height:auto;display:block;" />
</td></tr>

<!-- Titolo Auguri -->
<tr><td style="padding:48px 40px 20px;text-align:center;">
  <p style="margin:0;font-size:13px;letter-spacing:4px;text-transform:uppercase;color:#b39ddb;">Buona Pasqua 2026</p>
  <h1 style="margin:16px 0 0;font-size:32px;font-weight:400;color:#2d2426;line-height:1.3;font-family:'Georgia',serif;">
    La bellezza che nasce<br>dalla cura del cuore
  </h1>
</td></tr>

<!-- Corpo del messaggio -->
<tr><td style="padding:16px 40px 32px;text-align:center;">
  <p style="font-size:16px;line-height:1.8;color:#5a4a4e;margin:0 0 24px;">
    In questo giorno di rinascita e luce,<br>
    vogliamo ringraziarvi per aver scelto di camminare<br>
    al nostro fianco in un percorso che parte dal cuore.
  </p>
</td></tr>

<!-- Frase che rimane -->
<tr><td style="padding:0 40px 40px;">
  <table role="presentation" width="100%" cellpadding="0" cellspacing="0">
  <tr><td style="background-color:#f8f5f0;border-radius:12px;padding:32px;text-align:center;border-left:3px solid #b39ddb;">
    <p style="margin:0;font-size:20px;font-style:italic;color:#2d2426;line-height:1.6;font-family:'Georgia',serif;">
      &ldquo;Prendersi cura degli altri<br>
      e il modo piu bello<br>
      di prendersi cura di se stessi.&rdquo;
    </p>
  </td></tr>
  </table>
</td></tr>

<!-- Messaggio personale -->
<tr><td style="padding:0 40px 40px;text-align:center;">
  <p style="font-size:15px;line-height:1.7;color:#736366;margin:0;">
    Grazie per aver scelto una linea che parte dal cuore.<br>
    Ogni giorno, insieme, trasformiamo la cura in un gesto d'amore<br>
    per chi affronta il cammino piu difficile.
  </p>
  <p style="font-size:15px;line-height:1.7;color:#736366;margin:20px 0 0;">
    Vi auguriamo una Pasqua serena, piena di luce<br>
    e di quella forza gentile che ci unisce.
  </p>
</td></tr>

<!-- Separatore -->
<tr><td style="padding:0 40px;">
  <div style="height:1px;background:linear-gradient(to right,transparent,#d5a3ac,transparent);"></div>
</td></tr>

<!-- Firma -->
<tr><td style="padding:32px 40px;text-align:center;">
  <p style="margin:0;font-size:14px;color:#b39ddb;letter-spacing:2px;text-transform:uppercase;">Con affetto</p>
  <p style="margin:12px 0 0;font-size:22px;color:#2d2426;font-family:'Georgia',serif;font-weight:600;">ITA318</p>
  <p style="margin:6px 0 0;font-size:13px;color:#736366;">ODR — Oncocosmetics Derma Ritual</p>
  <p style="margin:4px 0 0;font-size:13px;color:#736366;">La Scienza del Benessere Applicata</p>
</td></tr>

<!-- Footer -->
<tr><td style="background-color:#2d2426;padding:28px 40px;text-align:center;border-radius:0 0 16px 16px;">
  <p style="margin:0;font-size:14px;color:#ffffff;font-weight:600;">ITA318 srl</p>
  <p style="margin:6px 0 0;font-size:12px;color:#a89ca0;">Galleria E. Tortora, 21 — 10121 Torino, Italia</p>
  <p style="margin:12px 0 0;font-size:12px;">
    <a href="https://odr.ioxina.com" style="color:#b39ddb;text-decoration:none;">odr.ioxina.com</a>
    <span style="color:#5a4a4e;"> &nbsp;|&nbsp; </span>
    <a href="https://odr-academy.it/benessere" style="color:#b39ddb;text-decoration:none;">La Scienza del Benessere</a>
  </p>
  <p style="margin:6px 0 0;font-size:11px;color:#5a4a4e;">
    info@ita318.it &nbsp;|&nbsp; accademia.odr@ita318.it
  </p>
  <p style="margin:16px 0 0;font-size:10px;color:#4a3a3e;">&copy; 2026 ITA318 srl — Tutti i diritti riservati</p>
</td></tr>

</table>

</td></tr>
</table>

</body>
</html>`;

export default function EasterEmailPage() {
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  const copyHTML = () => {
    navigator.clipboard.writeText(EASTER_HTML);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Toolbar */}
      <div className="sticky top-0 z-50 bg-white border-b border-gray-200 px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate(-1)} className="text-gray-500 hover:text-gray-700">
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-lg font-semibold text-gray-900" data-testid="easter-title">Email Auguri di Pasqua 2026</h1>
              <p className="text-xs text-gray-500">ODR | ITA318 — Per clienti, distributori e agenti</p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" onClick={copyHTML} data-testid="copy-html-btn">
              {copied ? <CheckCircle2 className="w-4 h-4 mr-2 text-green-500" /> : <Copy className="w-4 h-4 mr-2" />}
              {copied ? "Copiato!" : "Copia HTML"}
            </Button>
            <a href={`${process.env.REACT_APP_BACKEND_URL}/api/email-templates/easter-2026`} target="_blank" rel="noopener noreferrer">
              <Button size="sm" className="bg-blue-500 hover:bg-blue-600" data-testid="preview-link-btn">
                <ExternalLink className="w-4 h-4 mr-2" /> Link diretto
              </Button>
            </a>
          </div>
        </div>
      </div>

      {/* Email Preview */}
      <div className="max-w-4xl mx-auto py-8 px-4">
        <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-testid="email-preview">
          <iframe
            srcDoc={EASTER_HTML}
            title="Easter Email Preview"
            style={{ width: "100%", height: "1200px", border: "none" }}
          />
        </div>
      </div>
    </div>
  );
}
